/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Detail_Not_Found_DescriptionInputs */

const en_case_detail_not_found_description = /** @type {(inputs: Case_Detail_Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This case may have been deleted or the link is invalid.`)
};

const pt_br2_case_detail_not_found_description = /** @type {(inputs: Case_Detail_Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este caso pode ter sido excluído ou o link é inválido.`)
};

/**
* | output |
* | --- |
* | "This case may have been deleted or the link is invalid." |
*
* @param {Case_Detail_Not_Found_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_detail_not_found_description = /** @type {((inputs?: Case_Detail_Not_Found_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Detail_Not_Found_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_detail_not_found_description(inputs)
	return pt_br2_case_detail_not_found_description(inputs)
});